import { getTranslations } from "next-intl/server";
import { ShieldCheck, Truck, Lock } from "lucide-react";

export async function MiniTrustBar() {
	const t = await getTranslations("plp.miniTrust");

	const items = [
		{ icon: ShieldCheck, label: t("labTested") },
		{ icon: Truck, label: t("fastShipping") },
		{ icon: Lock, label: t("securePayment") },
	];

	return (
		<section
			className="bg-muted/30 flex items-center justify-center gap-6 border-b border-border px-4 py-3 sm:gap-8"
			aria-label={t("ariaLabel")}
		>
			{items.map(({ icon: Icon, label }) => (
				<div key={label} className="flex items-center gap-2 text-sm text-muted-foreground">
					<Icon className="h-4 w-4 shrink-0" aria-hidden />
					<span>{label}</span>
				</div>
			))}
		</section>
	);
}
